export class AdminLocationModel {
    admin_location_code: string
    admin_location_desc: string

    constructor(admin_location_code: string, admin_location_desc: string) {
        this.admin_location_code = admin_location_code
        this.admin_location_desc = admin_location_desc
    }
}
